import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config.service';
import { LoanSuggestedTerm, UserSuggestedTerm } from '../../model/rbi-compliance/loan-suggested-term.model';

@Injectable({
  providedIn: 'root'
})
export class LoanSuggestedTermService {

  constructor(private readonly http: HttpClient) { }

  async getLoanSuggestedTermByLoanId(loanId: string): Promise<any> {
    const url = `${ConfigService.getBaseUrl()}/loan-suggested-term/loan/${loanId}`;
    return await this.http.get(url).toPromise();
  }

  async getLoanSuggestedTermByLoanIdAndLenderId(loanId: string, lenderId: string): Promise<any> {
    const url = `${ConfigService.getBaseUrl()}/loan-suggested-term/loan/${loanId}/lender/${lenderId}`;
    return await this.http.get(url).toPromise();
  }

  async getLoanSuggestedTermByBorrowerProfileId(profileId: string): Promise<any> {
    const url = `${ConfigService.getBaseUrl()}/loan-suggested-term/borrower/${profileId}`;
    return await this.http.get(url).toPromise();
  }

  async createLoanSuggestedTerm(loanSuggestedTerm: LoanSuggestedTerm): Promise<any> {
    const url = `${ConfigService.getBaseUrl()}/loan-suggested-term`;
    return await this.http.post(url, loanSuggestedTerm).toPromise();
  }

  async updateLoanSuggestedTerm(id: string, userSuggestedTerm: UserSuggestedTerm): Promise<any> {
    const url = `${ConfigService.getBaseUrl()}/loan-suggested-term/${id}`;
    return await this.http.put(url, { userSuggestedTerm }).toPromise();
  }
}
